import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { wsGetAll } from 'services/WService.js';
import { onlyInteger } from 'hooks/Pipe';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { wsFindBy } from 'services/WService';

export default function ModalRule(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const [sellers, setSellers] = useState([]);
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);
  const [zonas, setZones] = useState([]);
  const [bureaus, setBureaus] = useState([]);
  const [products, setProducts] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listProducts() {
    let response = await wsFindBy('logi/product', { base_business_partner_id: 7, deleted_at: 'null', state: 'A' });
    if (response.success) setProducts(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);
  
  useEffect(() => {
    if (props.model?.open) {
      setDataChanging(props.model);
      listProducts();
    }
  }, [props.model]);

  return (
    <>
      <Modal
        title={`Actualizar registro`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        entity='sale/rango-cobertura'
        dataForce={{
          state: dataChanging.state,
          only_logi_product_id: dataChanging.only_logi_product_id,
        }}
      >
        <Autocomplete
          disableClearable
          options={products}
          getOptionLabel={(item) => `${item.ItemName} (Código: ${item.ItemCode})`}
          value={
            products.find(
              (item) =>
                String(item.id) === String(dataChanging.only_logi_product_id)
            ) || null
          }
          renderInput={(params) => (
            <TextField {...params} label="Producto exclusivo" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {
            handleChange("only_logi_product_id", item.id);
          }}
          required
        />
        <TextField
          label="Clientes Minimos"
          fullWidth
          type="number"
          name="min_coverage"
          margin="normal"
          defaultValue={dataChanging.min_coverage || ''}
        />
        <TextField
          label="Clientes maximos (Opcional)"
          fullWidth
          type="number"
          name="max_coverage"
          margin="normal"
          defaultValue={dataChanging.max_coverage || ''}
        />
        <TextField
          label="Ganancia"
          fullWidth
          type="number"
          name="ganancia"
          margin="normal"
          defaultValue={dataChanging.ganancia || ''}
        />
      </Modal>
    </>
  );
}
